import React from "react";

import usePageContent from "../../hooks/usePageContent";
import EditableSection from "../../components/CMS/EditableSection";
import("./CommunitySections.css");

import AdvisorsSection from "./AdvisorsSection";
import StudentAmbassadorsSection from "./StudentAmbassadorsSection";
import UniversityPartnersSection from "./UniversityPartnersSection";
import CountryDirectorSection from "./CountryDirectorSection";


import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const CommunityPage = ({ user }) => {

    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("community");


    const editable = !!user;


    if (loading) {
        return (
            <div className="container">
                <p>Loading...</p>
            </div>
        );
    }


    if (error) {
        return (
            <div className="container">
                <p>
                    Failed to load founders page.
                </p>
            </div>
        );
    }


    return (
        <>
             <EditableSection
                uniqueId="community-advisors"
                title="A Journey from Engineering to"
                data={get("advisors")}
                Display={AdvisorsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
          
            <EditableSection
                uniqueId="community-directors"
                title="A Journey from Engineering to"
                data={get("directors")}
                Display={CountryDirectorSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
       
            <EditableSection
                uniqueId="community-ambassadors"
                title="A Journey from Engineering to"
                data={get("ambassadors")}
                Display={StudentAmbassadorsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
              <EditableSection
                uniqueId="community-university"
                title="A Journey from Engineering to"
                data={get("university")}
                Display={UniversityPartnersSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
        </>
    );
};


export default CommunityPage;